import api from "./Api";

class CestService {
  GetCest(payload) {
    return api.get("/v1/cest/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCest(payload) {
    return api.post("/v1/cest/", payload).then((response) => {
      return response.data;
    });
  }

  PutCest(payload) {
    return api.put("/v1/cest/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCest(payload) {
    return api.delete("/v1/cest/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCestOData(payload) {
    return api.get("/OData/Cest" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CestService();
